<script lang="ts">
	import { _ } from 'svelte-i18n';
	import { page } from '$app/stores';
	import FastBtn from '$lib/component/fast-btn.svelte';
	import Footer from '$lib/component/footer.svelte';
	import Navbar from '$lib/component/navbar.svelte';
	import Partner from '$lib/component/partner.svelte';
	import { initHeroHomeSwiper } from '$lib/js/script.js';
	import { onMount } from 'svelte';

	import type { PageServerData } from './$types';
	export let data: PageServerData;

	const lang = $page.params.locale;

	let partner = data?.partner;
	let award = data?.award;

	onMount(() => {
		initHeroHomeSwiper();

		const script = document.createElement('script');
		script.src = 'https://unpkg.com/@phosphor-icons/web';
		script.async = true;
		document.head.appendChild(script);
	});
</script>

<svelte:head>
	<title>Contact - Holiday Inn Resort Bali Nusa Dua</title>
	<link rel="canonical" href="https://balinusadua.holidayinnresorts.com/en/contact" />
</svelte:head>

<Navbar />

<FastBtn />

<section id="contact">
	<div id="hero-banner" class="container-fluid p-0">
		<div class="w-100 h-100 p-md-0 p-0 position-relative overflow-hidden">
			<img alt="Holiday Inn Resorts Nusa Dua" src="/img/bg-header-contact.webp" class="img-header" />
			<div id="hero-text" class="position-absolute top-0 start-0 w-100 h-100">
				<!-- <div class="row g-0 w-100 h-100 justify-content-center align-items-center">
					<div class="col-md-6 text-center text-white p-3">
						<h1 class="ff-lola-bir display-3 mb-3">Dining</h1>
					</div>
				</div> -->
			</div>
		</div>
	</div>

	<div class="container py-md-5 py-3 mt-md-4">
		<div class="row g-0">
			<div class="col-md-8 mb-md-4 mb-3 px-md-4">
				<p class="mb-md-3 main-color fs-1 ff-lola-bir">{$_('contact_title_1')}</p>
				<p class="ff-helvetica">
					{$_('contact_desc_1')}
				</p>
			</div>
			<div class="col-md-6 p-md-4 mb-md-0 mb-4">
				<p class="mb-md-2 main-color fs-3 ff-lola-bir">{$_('contact_title_2')}</p>
				<div class="mb-4 ff-helvetica d-flex align-items-center">
					<i class="fw-bold me-1">Email: </i><a
						href="mailto:info@holidayinnbalinusadua.com"
						target="_blank"
						class="text-decoration-none text-black"
					>
						info@holidayinnbalinusadua.com</a
					>
				</div>

				<p class="mb-md-2 main-color fs-3 ff-lola-bir">{$_('contact_title_3')}</p>
				<div class="mb-4 ff-helvetica">
					<p class="mb-1">Holiday Inn Resort Bali Nusa Dua</p>
					<p class="mb-1">Jl. Pratama No.86, Tanjung, Benoa, Kec. Kuta Sel., Kabupaten Badung, Bali 80363 </p>
					<p class="mb-1">Phone: 0361 8947 888 (Front Desk)</p>
				</div>

				<p class="mb-md-2 main-color fs-3 ff-lola-bir">{$_('contact_title_4')}</p>
				<div class="mb-4 ff-helvetica d-flex align-items-center">
					<i class="fw-bold me-1">Email: </i><a
						href="mailto:reservation.nusadua@ihg.com"
						target="_blank"
						class="text-decoration-none text-black">reservation.nusadua@ihg.com</a
					>
				</div>
			</div>
			<div class="col-md-6 p-md-4">
				<p class="mb-md-3 main-color fs-3 ff-lola-bir">{$_('contact_title_5')}</p>

				<form
					id="form-contact"
					class="row g-0"
					action=""
					method="POST"
					enctype="multipart/form-data"
				>
					<div class="col-md-12 mb-3">
						<select class="form-control rounded-0" name="recepient" required>
							<option selected disabled>{$_('contact_opt_1')}</option>
							<option value="{$_('contact_opt_2')}">{$_('contact_opt_2')} </option>
							<option value="{$_('contact_opt_3')}">{$_('contact_opt_3')} </option>
							<option value="{$_('contact_opt_4')}">{$_('contact_opt_4')}</option>
							<option value="{$_('contact_opt_5')}">{$_('contact_opt_5')}</option>
						</select>
					</div>
					<div class="col-md-12 mb-3">
						<input
							type="text"
							class="form-control rounded-0"
							name="name"
							placeholder="{$_('contact_input_1')}"
							required
						/>
					</div>
					<div class="col-md-12 mb-3">
						<input
							type="email"
							class="form-control rounded-0"
							name="email"
							placeholder="{$_('contact_input_2')}"
							required
						/>
					</div>
					<div class="col-md-12 mb-3">
						<input
							type="text"
							class="form-control rounded-0"
							name="subject"
							placeholder="{$_('contact_input_3')}"
							required
						/>
					</div>
					<div class="col-md-12 mb-3">
						<textarea
							rows="5"
							class="form-control rounded-0"
							name="message"
							placeholder="{$_('contact_input_4')}"
							required
						></textarea>
					</div>
					<div class="col-12 mb-3">
						<div class="g-recaptcha" data-sitekey="6LfCYYQqAAAAAD9DIm-520gXzpZpoOw5bK6fAwBr"></div>
					</div>
					<div class="col-md-12 text-end">
						<button type="submit" class="btn main-btn rounded-0 px-4 py-2">{$_('btn_submit')}</button>
					</div>
				</form>
			</div>
		</div>
	</div>

	<div class="container-fluid p-0 mt-4 mb-4">
		<div class="d-none d-md-block">
			<div class="ratio ratio-21x9">
				<iframe
					src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3943.040376068527!2d115.22538189999999!3d-8.782271699999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dd2431aef0ff7a9%3A0xc00a38650ec14706!2sHoliday%20Inn%20Resort%20Bali%20Nusa%20Dua!5e0!3m2!1sid!2sid!4v1734580336697!5m2!1sid!2sid"
					width="100%"
					height="100%"
					loading="lazy"
					referrerpolicy="no-referrer-when-downgrade"
				></iframe>
			</div>
		</div>
		<div class="d-block d-md-none">
			<div class="ratio ratio-4x3">
				<iframe
					src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3943.040376068527!2d115.22538189999999!3d-8.782271699999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dd2431aef0ff7a9%3A0xc00a38650ec14706!2sHoliday%20Inn%20Resort%20Bali%20Nusa%20Dua!5e0!3m2!1sid!2sid!4v1734580336697!5m2!1sid!2sid"
					width="100%"
					height="100%"
					loading="lazy"
					referrerpolicy="no-referrer-when-downgrade"
				></iframe>
			</div>
		</div>
	</div>
</section>

<Partner {partner} />

<Footer {award} />

<style>
	
</style>
